import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { aggregateFollowersCount } from '../helpers';
import { formatThousands } from '../../../utils/formatter';

class KeyStatistics extends PureComponent {
    static propTypes = {
        lastNFollowers: PropTypes.array.isRequired,
        lastNDays: PropTypes.number,
        totalFollowers: PropTypes.number,
        lastNVisists: PropTypes.number,
    };

    render() {
        const lastNFollowersCount = aggregateFollowersCount(
            this.props.lastNFollowers
        );

        return (
            <React.Fragment>
                <div className="panel">
                    <h2>Nøkkeltall siste {this.props.lastNDays} dager</h2>
                </div>
                <div className="panel">
                    <div className="grid t-grid grid--cols1to3">
                        <div className="grid__unit">
                            <div className="u-text-center">
                                <p className="u-t2 u-mb0">
                                    {formatThousands(this.props.totalFollowers)}
                                </p>
                                <p className="mtn">følgere totalt</p>
                            </div>
                        </div>
                        <div className="grid__unit">
                            <div className="u-text-center">
                                <p className="u-t2 u-mb0">
                                    {formatThousands(lastNFollowersCount)}
                                </p>
                                <p className="mtn">nye følgere</p>
                            </div>
                        </div>
                        <div className="grid__unit">
                            <div className="u-text-center">
                                <p className="u-t2 u-mb0">
                                    {formatThousands(this.props.lastNVisists)}
                                </p>
                                <p className="mtn">nye unike besøk</p>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default KeyStatistics;
